import { render } from "./NumberOfIncidentsPerMonth.vue?vue&type=template&id=1812c85a"
import script from "./NumberOfIncidentsPerMonth.vue?vue&type=script&lang=js"
export * from "./NumberOfIncidentsPerMonth.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__